import React from 'react'
import { DateFormatted } from '../../../components/DateFormatted'
import { LinkExternal } from '../../../components/LinkExternal'
import { useOrderDetailContext } from '../OrderDetailContext'
import { graphql, useFragment } from '../../../gql'

const OrderInfo_CheckoutFragment = graphql(`
  fragment OrderInfo_CheckoutFragment on Checkout {
    id
    name
  }
`)

export const OrderInfo_OrderFragment = graphql(`
  fragment OrderInfo_OrderFragment on Order {
    id
    reservationNumber
    billNumber
    dateCreated
    dateExpedition
    priority
    createdBy {
      id
      name
    }
    checkout {
      ...OrderInfo_CheckoutFragment
    }
  }
`)

export const OrderInfo: React.FC = () => {
  const context = useOrderDetailContext()
  const order = useFragment(OrderInfo_OrderFragment, context.order)
  const checkoutData = order.checkout ? useFragment(OrderInfo_CheckoutFragment, order.checkout) : null

  const clientUrl = 'https://app.depoto.cz'

  const orderInfoItems = [
    { label: 'Pokladna', value: checkoutData?.name || '', isLink: false, isShowing: true },
    {
      label: 'Číslo rezervace',
      value: order.reservationNumber,
      isLink: !!order.reservationNumber,
      url: `${clientUrl}/order/${order.id}`,
      isShowing: !!order.reservationNumber,
    },
    {
      label: 'Číslo dokladu',
      value: order.billNumber,
      isLink: true,
      url: `${clientUrl}/order/${order.id}`,
      isShowing: !!order.billNumber,
    },
    { label: 'Datum vytvoření', value: order.dateCreated, isDate: true, isShowing: true },
    {
      label: 'Datum expedice',
      value: order.dateExpedition,
      isDate: true,
      isShowing: !!order.dateExpedition,
    },
    {
      label: 'Priorita',
      value: order.priority != null ? order.priority.toString() : '',
      isLink: false,
      isShowing: order.priority != null,
    },
    {
      label: 'Vytvořeno uživatelem',
      value: order.createdBy?.name,
      isLink: false,
      isShowing: !!order.createdBy?.name,
    },
  ]
  const visibleItems = orderInfoItems.filter(item => item.isShowing)

  const renderValue = (item: (typeof orderInfoItems)[0]) => {
    if (item.isDate) {
      return <DateFormatted date={item.value} hoursAndMins={true} />
    }

    if (item.isLink && item.url) {
      return <LinkExternal url={item.url}>{item.value}</LinkExternal>
    }

    return item.value || <span className="text-gray-400 italic">Nezadáno</span>
  }

  return (
    <div className={'flex flex-col gap-4'}>
      <h1 className={'text-black text-2xl font-bold'}>Informace</h1>
      <div className={'box'}>
        {visibleItems.map((item, index) => (
          <div
            key={item.label}
            className={`p-4 flex justify-between items-center ${index < visibleItems.length - 1 ? 'border-b border-cool-gray' : ''}`}>
            <div className={'text-base text-black font-semibold'}>{item.label}</div>
            <div className={`text-base`}>{renderValue(item)}</div>
          </div>
        ))}
      </div>
    </div>
  )
}
